import type { PremiumFeature, UserSubscription } from './types'
import { SUBSCRIPTION_GATING_ENABLED } from './feature-flags'

/** Maximum Little Roostrs per plan. */
export const MAX_ROOSTRS_FREE = 1
export const MAX_ROOSTRS_PENTHOUSE = 5

/** Check whether a subscription is active Penthouse (or free-mode unlock). */
export function isPenthouse(subscription: UserSubscription): boolean {
  // Temporary free mode: treat every user as Penthouse for UI gates.
  if (!SUBSCRIPTION_GATING_ENABLED) return true
  return subscription.plan === 'penthouse' && subscription.status === 'active'
}

/** Check whether a given premium feature is available for the subscription. */
export function canUseFeature(
  subscription: UserSubscription,
  feature: PremiumFeature
): boolean {
  if (!SUBSCRIPTION_GATING_ENABLED) return true
  if (isPenthouse(subscription)) return true
  // Free tier: all premium features are locked
  return false
}

/** Max allowed roostrs for the current subscription. */
export function maxRoostrs(subscription: UserSubscription): number {
  if (!SUBSCRIPTION_GATING_ENABLED) return MAX_ROOSTRS_PENTHOUSE
  return isPenthouse(subscription) ? MAX_ROOSTRS_PENTHOUSE : MAX_ROOSTRS_FREE
}

/** Human-readable labels for premium features. */
export const PREMIUM_FEATURE_LABELS: Record<PremiumFeature, { name: string; description: string }> = {
  extra_roostrs: {
    name: 'Up to 5 Agents',
    description: 'Deploy up to 5 agents to watch your saved searches simultaneously.',
  },
  instant_notifications: {
    name: 'Instant Frequency Updates',
    description: 'Get notified the moment a new listing matches your criteria — no waiting.',
  },
  just_the_facts: {
    name: 'Just the Facts',
    description: 'AI summarization that extracts only the property-specific details you care about.',
  },
  compare_mode: {
    name: 'Planner Compare Mode',
    description: 'AI-powered side-by-side comparison with scoring and personalized recommendations.',
  },
}

/** All premium features in display order. */
export const ALL_PREMIUM_FEATURES: PremiumFeature[] = [
  'extra_roostrs',
  'instant_notifications',
  'just_the_facts',
  'compare_mode',
]
